import type { WorkOrderPriceData, WorkOrderStatusEnum, WorkOrderActKc2Data } from 'gql/graphql';
import { ContractStatusEnum } from 'gql/graphql';
import type { CheckboxPropOnChange } from 'uikit';
import { Checkbox, Tooltip } from 'uikit';

import type React from 'react';
import { useRef, useState } from 'react';

import { DeletableWorkOrderItemsStatus, useDeletableWorkOrderItems } from '../hooks/useDeletableWorkOrderItems';

interface ICheckRowCell {
    row: WorkOrderPriceData;
    onChange?: CheckboxPropOnChange | undefined;
    checkedIds: Record<string, boolean>;
    workOrderStatus: WorkOrderStatusEnum | undefined;
    contractStatus: ContractStatusEnum | undefined;
    actsData: WorkOrderActKc2Data[];
    isDisabled?: boolean;
}

export const CheckRowCell: React.FC<ICheckRowCell> = (props) => {
    const { onChange, row, checkedIds, contractStatus, isDisabled, workOrderStatus, actsData } = props;

    const ref = useRef(null);
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const { id, type } = row;
    const isContractStatusWork = contractStatus === ContractStatusEnum.InImplementation;

    const deletableItems = useDeletableWorkOrderItems(row, actsData, workOrderStatus);

    const disabled =
        isDisabled ||
        !isContractStatusWork ||
        deletableItems?.status === DeletableWorkOrderItemsStatus.noDeletable ||
        (deletableItems?.status === DeletableWorkOrderItemsStatus.partlyDeletable &&
            !deletableItems?.deletableIds?.includes(id));
    const messages = deletableItems?.messages?.[type];
    const showMessage = messages?.itemsIds?.includes(id);

    return (
        <div ref={ref} onMouseEnter={() => setTooltipVisible(true)} onMouseLeave={() => setTooltipVisible(false)}>
            <Checkbox checked={checkedIds[id]} onChange={disabled ? undefined : onChange} disabled={disabled} />
            {showMessage && tooltipVisible && (
                <Tooltip size="s" direction="upCenter" anchorRef={ref}>
                    {messages?.message}
                </Tooltip>
            )}
        </div>
    );
};

CheckRowCell.displayName = 'CheckRowCell';
